'use client';

export default function MapSection() {
  return (
    <section className="py-8 sm:py-12 lg:py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-8 sm:mb-12">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3 sm:mb-4">
            Find Us Here
          </h2>
          <p className="text-gray-600 text-sm sm:text-base">
            Visit our wellness center for personalized consultations and product demonstrations
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
          <div className="relative w-full h-64 sm:h-80 lg:h-96">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3672.662535978538!2d77.798941315456!3d23.51399400457739!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x397d6d3c83f6f1bb%3A0x123456789abcdef!2sShastri%20Nagar%2C%20Vidisha%2C%20Madhya%20Pradesh%20464001!5e0!3m2!1sen!2sin!4v1691234567890!5m2!1sen!2sin"
              width="100%"
              height="100%"
              className="absolute inset-0"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="AyurVeda Office Location"
            ></iframe>
          </div>
          
          <div className="p-4 sm:p-6 lg:p-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 lg:gap-8">
              <div className="flex items-center space-x-3 sm:space-x-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-green-100 rounded-full flex-shrink-0">
                  <i className="ri-map-pin-line text-green-600 text-lg sm:text-xl"></i>
                </div>
                <div>
                  <div className="font-semibold text-gray-900 text-sm sm:text-base">Address</div>
                  <div className="text-gray-600 text-xs sm:text-sm">Hospital road Balvihar vidisha madhya pradesh 464001</div>
                </div>
              </div>
              
              <div className="flex items-center space-x-3 sm:space-x-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-blue-100 rounded-full flex-shrink-0">
                  <i className="ri-car-line text-blue-600 text-lg sm:text-xl"></i>
                </div>
                <div>
                  <div className="font-semibold text-gray-900 text-sm sm:text-base">Parking</div>
                  <div className="text-gray-600 text-xs sm:text-sm">Free parking available</div>
                </div>
              </div>
              
              {/* <div className="flex items-center space-x-4">
                <div className="w-12 h-12 flex items-center justify-center bg-purple-100 rounded-full">
                  <i className="ri-train-line text-purple-600 text-xl"></i>
                </div>
                <div>
                  <div className="font-semibold text-gray-900">Transit</div>
                  <div className="text-gray-600 text-sm">Metro accessible</div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}